var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityDefaultImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7,
    cy: 17.7,
    r: 17.2,
    fill: "white",
    stroke: "#A8A4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3629 25.7109V18.8347H19.957V25.7109H18.6679V17.5457H23.0154V10.194H21.5663V7.31374H19.9265V5H18.6374V7.31374H16.9975V10.194H15.5484V25.7109H14.2593V13.0743H8.63707V25.7109H7V27H29V25.7109H27.3629ZM20.0775 11.7852H21.3666V13.0743H20.0775V11.7852ZM20.0775 14.6654H21.3666V15.9545H20.0775V14.6654ZM12.0643 25.2054H10.7752V23.9163H12.0643V25.2054ZM12.0643 22.1218H10.7752V20.8327H12.0643V22.1218ZM12.0643 19.0381H10.7752V17.7491H12.0643V19.0381ZM12.0643 15.9545H10.7752V14.6654H12.0643V15.9545ZM18.4863 15.9545H17.1973V14.6654H18.4863V15.9545ZM18.4863 13.0743H17.1973V11.7852H18.4863V13.0743ZM18.6374 8.90491H19.9264V10.194H18.6374V8.90491ZM22.8553 25.7109H21.5663V20.5375H22.8553V25.7109ZM25.7537 25.7109H24.4646V20.5375H25.7537V25.7109Z",
    fill: "#D3D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityDefaultImg);
export default __webpack_public_path__ + "static/media/city_default_img.4a2bd3a3ef90c179679411dc47055530.svg";
export { ForwardRef as ReactComponent };